export const ROOT = 'http://localhost:3000';

export const REQUEST_POSTS = 'REQUEST_POSTS';
export const REQUEST_PROJECTS = 'REQUEST_PROJECTS';

export const RECEIVE_POSTS = 'RECEIVE_POSTS';
export const RECEIVE_PROJECTS = 'RECEIVE_PROJECTS';
